/**
 * @providesModule schema
 * 
 */

export const orderedSchemas = [
  'researchers',
  'software',
  'hardware',
  'grants',
  'works',
]

export const schemasMap = {
  researchers: 'Researchers',
  software: 'Software',
  hardware: 'Hardware',
  grants: 'Grants',
  works: 'Works',
}
